// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-3[data-v-ef0c2ace]{gap:12px}", ""]);
// Exports
module.exports = exports;
